import { Button } from 'utils/Button';
import hero from '../assets/final/landing/hero.webp';
import {
  googleRatingData,
  formatRatingDisplay,
  formatReviewCount
} from '../data/GoogleRating';

const RatingBadge = () => (
  <div className="flex gap-2 items-center text-white/90">
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((_, i) => (
        <svg
          key={i}
          className="w-5 h-5 text-yellow-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.18c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.175 0l-3.385 2.46c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.045 9.394c-.783-.57-.38-1.81.588-1.81h4.18a1 1 0 00.95-.69l1.286-3.967z" />
        </svg>
      ))}
    </div>
    <span className="text-lg font-medium">
      {formatRatingDisplay(googleRatingData.rating)} on Google
    </span>
  </div>
);

export const Hero = () => {
  return (
    <div>
      <div className="h-[90vh] sm:h-[85vh] md:h-[80vh] w-full relative">
        <div className="absolute top-0 left-0 z-10 w-full h-full">
          <div className="grid content-center px-4 mx-auto w-full max-w-7xl h-full sm:px-6 md:px-8">
            <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in">
              {/* Main Content */}
              <div className="space-y-3 sm:space-y-4 md:space-y-6">
                <h1 className="mx-auto max-w-4xl text-3xl font-bold leading-tight text-center text-white sm:text-4xl md:text-5xl lg:text-6xl">
                  Crafting Beautiful Spaces That Feel Like Home
                </h1>
                <p className="mx-auto max-w-2xl text-base font-light text-center text-white/90 sm:text-lg md:text-xl">
                  Specializing in kitchens, bathrooms, and custom cabinets for
                  Utah homes
                </p>
              </div>

              {/* Divider */}
              <div className="mx-auto w-20 sm:w-24 h-[1px] bg-white/30"></div>

              {/* Years of Service */}
              <h2 className="text-sm font-medium tracking-wide text-center sm:text-base text-white/80 md:text-lg">
                Serving Utah Communities for Over 35 Years
              </h2>

              {/* Rating Section */}
              <div className="flex flex-col items-center space-y-1 sm:space-y-2">
                <a
                  href={googleRatingData.reviewUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group">
                  <RatingBadge />
                  <div className="flex justify-center items-center mt-1 text-xs sm:mt-1.5 sm:text-sm">
                    <span className="text-white/70">
                      Based on{' '}
                      <span className="font-medium text-white/90">
                        {formatReviewCount(googleRatingData.reviewCount)}
                      </span>
                    </span>
                  </div>
                </a>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col gap-3 justify-center items-center mt-4 sm:mt-6 md:flex-row md:gap-4 md:mt-8">
                <Button
                  to="/gallery"
                  text="VIEW OUR WORK"
                  classname="px-6 py-3 w-full text-sm text-gray-900 bg-white transition-colors sm:px-8 md:w-auto hover:bg-gray-100 sm:text-base"
                />
                <Button
                  to="/contact"
                  text="GET FREE CONSULTATION"
                  classname="px-6 py-3 w-full text-sm text-white bg-blue-600 transition-colors sm:px-8 md:w-auto hover:bg-blue-700 sm:text-base"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Background Overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/60 via-black/40 to-black/50"></div>

        {/* Hero Image */}
        <div className="bg-[#2C353A] w-full h-full">
          <img
            src={hero}
            className="object-cover flex-shrink-0 w-full h-full bg-no-repeat"
            alt="a kitchen remodel built by oak and stone in ogden utah, featuring beautiful custom cabinets and marble countertops"
            loading="eager"
            priority="true"
          />
        </div>
      </div>
    </div>
  );
};
